initSectionIngredients();
function initSectionIngredients() {
  const lightboxBtn = document.querySelectorAll(".lightbox-btn");
  const html = document.documentElement;
  // Get the dialog element and open when clicking the button
  for (const btn of lightboxBtn) {
    const dialog = btn.nextElementSibling;
    const inner = dialog.firstElementChild;
    const closeBtn = dialog.querySelector(".lightbox-close");
    const video_full = dialog.querySelector("video");

    btn.addEventListener("click", () => {
      dialog.style.display = "block";
      html.style.overflow = "hidden";
      video_full.play();
    });

    // Close events
    closeBtn.addEventListener("click", (e) => {
      closeModal();
    });
    dialog.addEventListener("click", (e) => {
      if (e.target === inner) closeModal();
    });

    function closeModal() {
      dialog.style.display = null;
      video_full.pause();
      html.style.overflow = null;
    }
  }

  // Set simple play, pause video controls and add playing, paused classes to parent element, include class for loading that removes when video is ready
  const videos = document.querySelectorAll(".lightbox-dialog video");
  for (const video of videos) {
    const parent = video.parentElement;

    video.addEventListener("play", () => {
      parent.classList.add("playing");
      parent.classList.remove("paused");
    });
    video.addEventListener("pause", () => {
      parent.classList.add("paused");
      parent.classList.remove("playing");
    });
    video.addEventListener("waiting", () => {
      parent.classList.add("loading");
    });
    video.addEventListener("canplay", () => {
      parent.classList.remove("loading");
    });

    // Set simple video controls
    video.addEventListener("click", () => {
      if (video.paused) {
        video.play();
      } else {
        video.pause();
      }
    });
  }
}
